export default {
    name: "zh_TW",
    messages: {
        _default: function (field) {
            return "無效"
        },
        after: function (field, args) {
            return "須晚於 " + args[0]
        },
        alpha: function (field) {
            return "只允許字母"
        },
        alpha_dash: function (field) {
            return "只允許字母、數字及斜線"
        },
        alpha_num: function (field) {
            return "只允許字母、數字"
        },
        alpha_spaces: function (field) {
            return "只允許字母、空格"
        },
        before: function (field, args) {
            return "須早於 " + args[0]
        },
        between: function (field, args) {
            return "須在 " + args[0] + " 至 " + args[1] + "之間"
        },
        confirmed: function (field, args) {
            // return "與 " + args[0] + " 不一致"
            return "輸入不一致"
        },
        credit_card: function (field) {
            return "格式錯誤"
        },
        date_between: function (field, args) {
            return "須在 " + args[0] + " 和 " + args[1] + " 之間"
        },
        date_format: function (field, args) {
            return "不符合 " + args[0] + " 的格式"
        },
        decimal: function (field, args) {
            void 0 === args && (args = []);
            var t = args[0];
            return void 0 === t && (t = "*"), "須為數字，且可保留 " + ("*" === t ? "" : t) + " 位小數"
        },
        digits: function (field, args) {
            return "須為 " + args[0] + " 位數字"
        },
        dimensions: function (field, args) {
            return "尺寸錯誤，須為 " + args[0] + "*" + args[1]
        },
        email: function (field) {
            return "須為有效之電子郵件地址"
        },
        emails: function (field) {
            return "須為有效之電子郵件地址"
        },
        excluded: function (field) {
            return "無效"
        },
        ext: function (field) {
            return "須為有效檔案"
        },
        image: function (field) {
            return "須為圖片"
        },
        included: function (field) {
            return "無效"
        },
        integer: function (field) {
            return "須為整數"
        },
        ip: function (field) {
            return "須為有效的 IP 位址"
        },
        length: function (field, args) {
            var t = args[0],
                r = args[1];
            return r ? "長度須為 " + t + " 至 " + r + " 之間" : "長度必須為 " + t
        },
        max: function (field, args) {
            return "不能大於 " + args[0] + " 個字元"
        },
        max_value: function (field, args) {
            return "不得大於 " + args[0]
        },
        mimes: function (field) {
            return "須為有效的檔案類型"
        },
        min: function (field, args) {
            return "不能小於 " + args[0] + " 個字元"
        },
        min_value: function (field, args) {
            return "不得小於 " + args[0]
        },
        numeric: function (field) {
            return "須為數字"
        },
        regex: function (field) {
            return "格式錯誤"
        },
        required: function (field) {
            return "必填"
        },
        size: function (field, args) {
            var t, r, u, i = args[0];
            return "大小須小於 " + (t = i, r = 1024, u = 0 == (t = Number(t) * r) ? 0 : Math.floor(Math.log(t) / Math.log(r)), 1 * (t / Math.pow(r, u)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][u]) + "."
        },
        url: function (field) {
            return "格式錯誤"
        },
        multiple_of: function (field, args) {
            return "請輸入 "+ args +" 的倍數"
        },
    }
}
